import { Injectable } from '@angular/core';
import { EncryptedLocalStorageService } from '../storage';
import { PendoEventName, PendoEventProperties } from './events';

declare const pendo;

@Injectable({
	providedIn: 'root',
})
export class PendoService {
	constructor(private storage: EncryptedLocalStorageService) {}

	initializePendo() {
		if (typeof pendo !== 'undefined') {
			const roles = this.storage.retrieve('roles');
			pendo.initialize({
				visitor: {
					id: this.storage.retrieve('_id'),
					email: this.storage.retrieve('email'),
					fullName: this.storage.retrieve('employeeName'),
					role: roles ? JSON.parse(roles) : [],
					defaultDivision: this.storage.retrieve('employeeDivision'),
					branch: this.storage.retrieve('employeeBranch'),
					userType: 'internal',
				},
			});
		} else {
			console.error('Pendo is not defined');
		}
	}

	/**
	 * Emite un evento personalizado a Pendo con propiedades tipadas
	 * @param eventName Nombre del evento desde PendoEventName
	 * @param properties Propiedades según el tipo de evento
	 */
	emitEvent<T extends PendoEventName>(eventName: T, properties: PendoEventProperties[T]): void {
		console.log('[pendo] try emitEvent', eventName, properties);
		if (pendo?.isReady()) {
			pendo.track(eventName, properties);
			console.log('[pendo] emitEvent completed');
		} else {
			console.error('Pendo no inicializado');
		}
	}
}
